import Ads from "../Ads/Ads.component";
import ChanelAd from "../images/p_channel01.jpg";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import Left from "./Left.component";
import Right from "../Components/Right.component";
import { useEffect, useRef, useState } from "react";

const InfoDetail = () => {
  const [detail, setDetail] = useState({}); // [1]
  const [Params] = useSearchParams();
  const key = Params.get("key");
  const firstUpdate = useRef(true);
  let title = "";
  switch (key) {
    case "yszc":
      title = "隐私政策";
      break;
    case "gszs":
      title = "公司证书";
      break;
    case "yyzz":
      title = "营业执照";
      break;
    case "flsm":
      title = "法律声明";
      break;
  }
  useEffect(() => {
    // if (firstUpdate.current) {
    //   console.log("firstUpdate");
    //   firstUpdate.current = false;
    //   return;
    // }
    async function fetchData() {
      const res = await fetch(
        `https://htadmin.biandanbao.com/api/config/show?key=${key}`
      );
      const data = await res.json();
      console.log(data);
      setDetail({
        id: data.id,
        title: data.title,
        content: data.content,
      });
    }
    fetchData();
  }, [key]);
  return (
    <>
      <div
        style={{ backgroundImage: "url(/images/bg_channel.png)" }}
        className="flex  justify-center"
      >
        <Ads src={ChanelAd} width="1047" height="127" />
      </div>
      <div className="flex w-[1200px] my-[20px] ml-[150px]">
        <span>
          <span>当前位置：</span>
          <Link to="/">首页 &gt;</Link>
          <Link to={`/config?key=${key}`}>{title}</Link>
        </span>
      </div>
      <div className=" flex justify-center w-[1200px] mx-auto gap-[50px] ">
        <Left detail={detail}></Left>
        <Right></Right>
      </div>
    </>
  );
};
export default InfoDetail;
